<p>confirmation-modal works!</p>
